<section class="breadcrumb-section">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<div class="breadcrumb-title">
					<h1>Student Life</h1>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="section-lg std-scholarship">
	<div class="container">
		<div class="sec-title text-center">
			<h2>Students <span>Cell</span></h2>

		</div>
		<div class="row row-50">
			<div class="col-md-3">
				<div class="vertical-tabs">
					<ul class="nav nav-pills flex-column" id="myTab" role="tablist">
						<li class="nav-item">
							<a class="nav-link active" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab"
								aria-controls="tab1" aria-selected="true">Education cell
							</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab4-tab" data-toggle="tab" href="#tab4" role="tab"
								aria-controls="tab4" aria-selected="false">Cultural Cell</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab10-tab" data-toggle="tab" href="#tab10" role="tab"
								aria-controls="tab10" aria-selected="false">Industry Institute Interaction (III)
								cell</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab13-tab" data-toggle="tab" href="#tab13" role="tab"
								aria-controls="tab13" aria-selected="false">Encarta - IT Cell</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="col-md-9">
				<div class="tab-content" id="myTabContent">
					<div class="tab-pane fade show active" id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
						<div class="section-title">
							<h4>Education cell
							</h4>
						</div>
						<div class="text-justify">
							<p>Gyan Manthan - The Management Fest The management fest is purely an in-houseactivity,
								wherein students from commerce and allied fields i.e. finance, banking, managementetc.
								take part in various events, that involve development of skills, needed in real-life
								business situations.</p>
							<p>The unexplored and hidden talent and potential of the students are given the platform of
								Finance, Marketing, Human Resource, Technology& Business Plan. It showcases various
								events in the form of business research, preparing finance dictionary, promotion of
								products to inculcate corporate work culture and business ethics among students.</p>
							<p>Edification- The Education Club The Education Club brings together students to engage
								with leaders in the field, discuss current education issuesand connect through
								networking opportunities.The purpose of this organization is to facilitate communication
								and support to students interested in the current trends of education. The goal is to
								sponsor various professional activities and social events so that students caninteract
								with professionals in this field and exchange their ideas with them. They can update
								themselves through the various activities conducted under the club like Creative
								writing, Slogan making, storytelling etc.</p>
						</div>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/mng_fest-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/mng_fest-1.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Management Fest</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/mng_fest-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/mng_fest-2.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Management Fest</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/mng_fest-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/mng_fest-3.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Management Fest</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/mng_fest-4.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/mng_fest-4.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Management Fest</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/MUN.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/MUN.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Model United Nations</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/tecnovision.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/tecnovision.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Techno Vision</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">
						<div class="section-title">
							<h4>Cultural Cell
							</h4>

						</div>
						<div class="text-justify">
							<p>Cultural awareness and participation play an integral role in a student's education.</p>
							<p>Our cultural Cell has the following aims:</p>
							<ul class="list-item mb-2">
								<li>To give all students the opportunity to be involved in culturally enriching
									activities.</li>
								<li>To give those students with special talents a chance to extend themselves and to
									grow in their area of expertise.</li>
								<li>To expand our students’ appreciation of cultural activities.</li>
							</ul>
							<p>Some of the important cultural activities in College are:</p>
							<ul class="list-item mb-2">
								<li>Fresher’s party</li>
								<li>Indradhanu –The Annual Gathering</li>
								<li>Deep Ramzan- Diwali and Eid celebration</li>
								<li>Farewell Party</li>
							</ul>
						</div>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/freshers-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/freshers-1.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Fresher’s party</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/freshers-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/freshers-2.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Fresher’s party</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/freshers-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/freshers-3.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Fresher’s party</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/indradhanu.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/indradhanu.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Indradhanu</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/deep_ramzan-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/deep_ramzan-1.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Deep Ramzan</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/deep_ramzan-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/deep_ramzan-2.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Deep Ramzan</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/farewell-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/farewell-1.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Farewell Party</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/farewell-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/farewell-2.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Farewell Party</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/farewell-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/farewell-3.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Farewell Party</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/farewell-4.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/farewell-4.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Farewell Party</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="tab10" role="tabpanel" aria-labelledby="tab10-tab">
						<div class="section-title">
							<h4>Industry Institute Interaction (III) cell
							</h4>

						</div>
						<div class="text-justify">
							<p>III Cell is an important wing for any institution to promote knowledge with the
								advancement of technology. GHRCCT helps students to get the practical knowledge &
								experience with the help of live projects & small internship programmes and industry
								institute interaction.</p>
							<p>The major functions of III cell are :</p>
						</div>
						<ul class="list-item">
							<li>Live Project: Students are encouraged to understand the importance of live projects as
								it helps to develop the skills and let them experience the real world of the work.</li>
							<li>Guest Lectures: Distinguished dignitaries with years of experience in their fields are
								invited to share their experiences with the students on topics like Financial Litracy,
								Business &amp; Market Research , Business Plan etc.</li>
							<li>Industrial Visits: One of the great experiences of our college is an industrial visit.
								This gives students the opportunity to understand the actual operations of any industry.
							</li>
							<li>Internship programs – Internship programs are offered to the students, which is optional
								in nature. Students are encouraged to undergo internship to have a feel of practical
								exposure and training in various industries. </li>
							<li>Training and Placement: The Goal of training and placement cell is to provide employment
								opportunities to the students. Facilitates the students to master their skills by the
								practical exposure from the industry. Our students while pursuing graduation got the
								opportunity to face the campus interviews with various companies like IBM Daksh.
								Concentrix , Infosys, Bookzevents.com, Amazon , TCS etc.</li>
						</ul>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/iii_morarjee.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/iii_morarjee.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Industrial Visit Morarjee Texttile</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/iii_CETP.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/iii_CETP.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Industrial Visit CETP Water Treatment Plant</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/iii_guest.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/iii_guest.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Guest Lecture</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/iii_jain_farm.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/iii_jain_farm.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Industrial Visit Jain Farm Fresh, Jalgaon</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="tab13" role="tabpanel" aria-labelledby="tab13-tab">
						<div class="section-title">
							<h4>Encarta - IT Cell
							</h4>

						</div>
						<div class="text-justify">
							<p>“Encarta - The IT Cell” provides knowledge to the students in the field of Information
								Technology. It provides effective support to improve students’ academic performance. It
								updates students with the information from latest technology to working in the IT sector
								and also on the top companies in the IT field. It also improves students’ engagement in
								college and external activities which include but are not limited to industry visits,
								seminars, workshops and training and stimulate social responsibility awareness which
								will assist them to learn, grow and fully prepare to face the challenges in life outside
								the campus and global workforce</p>
						</div>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-5">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/techno-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/techno-1.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Press Release on IT CELL (Techno Quiz) Competition</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-5">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/techno-5.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/techno-5.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Glimpse of the Techno Quiz Competition</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-5">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/software-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/software-1.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Glimpse of the Two Day’s Workshop on Software Testing</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-5">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/software-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/software-2.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Glimpse of the Two Day’s Workshop on Software Testing</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-5">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/software-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/software-3.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Glimpse of the Two Day’s Workshop on Software Testing</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/enc_champion-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/enc_champion-1.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Kaun Banega Champion</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/enc_champion-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/enc_champion-2.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Kaun Banega Champion</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/enc_champion-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/enc_champion-3.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Kaun Banega Champion</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/enc_champion-4.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/enc_champion-4.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Kaun Banega Champion</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/poker_face-6.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/poker_face-6.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Poker Face</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/poker_face-4.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/poker_face-4.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Poker Face</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/poker_face-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/poker_face-1.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Poker Face</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/poker_face-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/poker_face-2.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Poker Face</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/poker_face-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/poker_face-3.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Poker Face</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/enc_gl-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/enc_gl-2.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Guest Lecture</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/enc_gl-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/enc_gl-1.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Guest Lecture</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/enc_gl-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/enc_gl-3.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Guest Lecture</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/deal_nodeal.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/deal_nodeal.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Deal or No Deal</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
						<ul class="list-item">
							<li><a href="https://drive.google.com/file/d/1fsKV7RsLiuleOG5kcLguq_uIgM-HbISd/view?usp=sharing"
									target="_blank">Press Release on IT CELL(Techno Quiz)Competition</a></li>
							<li><a href="https://drive.google.com/file/d/1NA4u1AWI2nkUtCh69bBhPbMXPoBfg4No/view?usp=sharing"
									target="_blank">Two days workshop on Software Testing 2022 Report…</a></li>
							<li><a href="https://drive.google.com/file/d/1v9SZ8Fosq7hVB8P5Q-0fPa-b81Myt7qM/view?usp=sharing"
									target="_blank">Poker Face 2022 Report</a></li>
							<li><a href="https://drive.google.com/file/d/1vwziH5NgCtcjmElX-XOaxj4w1DduuRET/view?usp=sharing"
									target="_blank">TechnoQuiz Competition.</a></li>
						</ul>

					</div>

				</div>
			</div>
		</div>
	</div>
</section>
<section class="section-lg std-scholarship">
	<div class="container">
		<div class="sec-title text-center">
			<h2>Students<span> Clubs</span></h2>

		</div>
		<div class="row row-50">
			<div class="col-md-3">
				<div class="vertical-tabs">
					<ul class="nav nav-pills flex-column" id="myTab" role="tablist">
						<li class="nav-item">
							<a class="nav-link active" id="tab2-tab" data-toggle="tab" href="#tab2" role="tab"
								aria-controls="tab2" aria-selected="true">Natures Club</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab7-tab" data-toggle="tab" href="#tab7" role="tab"
								aria-controls="tab7" aria-selected="false">Literature Club</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab9-tab" data-toggle="tab" href="#tab9" role="tab"
								aria-controls="tab9" aria-selected="false">Fitness Club</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab12-tab" data-toggle="tab" href="#tab12" role="tab"
								aria-controls="tab12" aria-selected="false">Creative Club</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab14-tab" data-toggle="tab" href="#tab14" role="tab"
								aria-controls="tab14" aria-selected="false">Rotaract Club</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="col-md-9">
				<div class="tab-content" id="myTabContent">
					<div class="tab-pane fade show active" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">
						<div class="section-title">
							<h4>Natures Club
							</h4>

						</div>
						<div class="text-justify">
							<p>Today our society is facing lot of problems related to environment. Moreover, today
								students are more connected to people all over the world but less connected to the near
								and dear ones and the nature. Taking this into consideration, Nature Club in our GHRCCST
								college, sorts out some activities which help them to connect, to our ‘Mother Earth’.
								The Nature Club conducts various activities such as recycling, environment painting
								wasp, throughout the year.</p>
							<p>The Nature Club aims at inculcating an appreciation of nature among students and
								encouraging them to participate in a variety of conservation initiatives. Its efforts
								include inviting leading environmentalists to the college to talk to students and
								sensitize them to the opportunities and challenges in addressing environmental issues,
								organizing an annual tree-planting day, and participating in important nature-oriented
								programs. Students also work on recycling waste and reduction of consumption on campus
								by recycling paper and providing support to the rag-pickers of Nagpur.</p>
							<p>The school works towards making the school campus an eco-friendly place. There are bins
								to segregate garbage, ‘Bio Degradable and ‘Recyclable Material Bin’. The bio degradable
								material is safely disposed off while the recyclable material is again handed over to
								FORCE for further processing.</p>
						</div>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nature1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nature1.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Natures Club</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nature2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nature2.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Natures Club</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nature3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nature3.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Natures Club</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nature4.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nature4.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Natures Club</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="tab7" role="tabpanel" aria-labelledby="tab7-tab">
						<div class="section-title">
							<h4>Literature Club
							</h4>

						</div>
						<div class="text-justify">
							<p>The Literature Club has been formed to develop the inclination of the students towards
								the literature learning in three basic language i.e. English, Hindi and Marathi. The
								Club conducts various activities like Slogan Writing, Story Writing, Literature work
								shop, Poetry Writing, Book review, Kavi sammelan / Skit Presentation, Paper
								presentation, etc. The students are awarded with certificates and prizes for
								participation in different competitions organized by the club. The activities are
								conducted round the year under the direction of the in charge of the club Prof. Kalyani
								Dubey. The Club is raising its standard with each event conducted under the guidelines
								of Dr. Aarti Deshpande (Principal, G H Raisoni College of Commerce, Science and
								Technology).</p>
						</div>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/lit-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/lit-1.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Club Installation</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/lit-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/lit-2.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Story writing Competition</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/lit-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/lit-3.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Poetry writing Competition</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/lit-4.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/lit-4.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Slogan writing Competition</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="tab9" role="tabpanel" aria-labelledby="tab9-tab">
						<div class="section-title">
							<h4>Fitness Club
							</h4>

						</div>
						<div class="text-justify">
							<p>What does it mean to be fit? Finding a discrete definition is somewhat difficult.
								According to the dictionary, fitness means: “the quality or state of being fit." If you
								find those words somewhat vague, you’re not alone.</p>
							<p>And that’s sort of the point, according to exercise experts. Fitness doesn’t have to mean
								that you’re an ultra-marathoner or that you can perform one pull-up or one hundred.
								Fitness can mean different things for different people.</p>
							<p>“For GHRCCST, fitness is first and foremost about feeling good and being able to move
								without pain”. The fitness club explains that true fitness is about feeling healthy and
								being in sufficient shape to do the activities you want to do and live the lifestyle you
								want to live. But physical fitness should not solely be measured with any one of these
								or other tests or evaluations. Traditionally, college have defined five key components
								of physical fitness: body composition, cardiorespiratory or aerobic fitness,
								flexibility, muscular strength, and muscular endurance. The club balances all the
								components to give the best to its students.</p>
						</div>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/fitness-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/fitness-1.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Fitness Club</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/fitness-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/fitness-2.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Fitness Club</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/fitness-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/fitness-3.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Fitness Club</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/fitness-4.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/fitness-4.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Fitness Club</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="tab12" role="tabpanel" aria-labelledby="tab12-tab">
						<div class="section-title">
							<h4>Creative Club
							</h4>

						</div>
						<div class="text-justify">
							<p>Creative Club is an initiative to make classroom environments more creative and
								interesting!!!</p>
							<p>The purpose of the creative club is to simulate interest in creative ideas among
								students. This programs gives an opportunity for students to develop their interactions
								among groups, helps enhance their creative and leadership skills. The club attempts to
								create an awareness of student mind by organizing activities like Poster making, Tattoo
								making, Ad Mad show, best out of waste etc</p>
						</div>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/enc_champion-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/creative_club-1.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Creative Club</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/creative_club-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/creative_club-2.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Creative Club</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/creative_club-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/creative_club-3.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Creative Club</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/stc-fina.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/stc-fina.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Reading of financial statements</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="tab14" role="tabpanel" aria-labelledby="tab14-tab">
						<div class="section-title">
							<h4>Rotaract Club
							</h4>

						</div>
						<div class="text-justify">
							<p>GHRCCST’s ROTARACT Club is club of students, teachers, management and problem-solvers who
								see a city where people unite and take action to create lasting change – across the
								state, country, in our communities, and in ourselves. Our club is having main objective
								to inculcate moral, social responsibilities in students which can make them better for
								coming future.</p>
							<p>Students in our Rotaract interacts, helps society for commencement of knowledge,
								awareness & skills for crating base for youngsters. We provide service to needy, promote
								integrity, and advance world understanding, goodwill, and peace through our fellowship
								of management.</p>
							<p>Rotaract clubs bring together people ages 18-30 to exchange ideas with leaders in the
								community, develop leadership and professional skills, and have fun through service.In
								communities worldwide, Rotaract members work side by side to take action through
								service. From Nagpur city to rural villages, Rotaract is changing communities.</p>
							<p>Rotaract members decide how to organize and run their clubs, manage their own funds, and
								plan and carry out activities and service projects. Rotaract club used sponsors offer
								guidance and support and work with your club as partners in service.</p>
						</div>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/rota_beti.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/rota_beti.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Rotaract Beti Bachao Bati Padhao Mission</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/rota_blood.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/rota_blood.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Rotaract Blood Donation Camp</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/rota_ganpati.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/rota_ganpati.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Rotaract Ganpati Visarjan Nirmalya Program</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/rota_hcl.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/rota_hcl.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Rotaract HCL Marathon Meadal Ceremony</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/rota_police.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/rota_police.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Rotaract Police Day</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="section-lg std-scholarship">
	<div class="container">
		<div class="sec-title text-center">
			<h2>Students <span>Activity</span> </h2>

		</div>
		<div class="row row-50">
			<div class="col-md-3">
				<div class="vertical-tabs">
					<ul class="nav nav-pills flex-column" id="myTab" role="tablist">
						<li class="nav-item">
							<a class="nav-link active" id="tab3-tab" data-toggle="tab" href="#tab3" role="tab"
								aria-controls="tab3" aria-selected="true">NSS Activity</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab5-tab" data-toggle="tab" href="#tab5" role="tab"
								aria-controls="tab5" aria-selected="false">Aarambh Induction</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab6-tab" data-toggle="tab" href="#tab6" role="tab"
								aria-controls="tab6" aria-selected="false">Toastmaster</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab8-tab" data-toggle="tab" href="#tab8" role="tab"
								aria-controls="tab8" aria-selected="false">Engfinity</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab11-tab" data-toggle="tab" href="#tab11" role="tab"
								aria-controls="tab11" aria-selected="false">Short term course</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab15-tab" data-toggle="tab" href="#tab15" role="tab"
								aria-controls="tab15" aria-selected="false">Sahas - Adventure Camp</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab16-tab" data-toggle="tab" href="#tab16" role="tab"
								aria-controls="tab16" aria-selected="false">Saraswati Pooja</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab17-tab" data-toggle="tab" href="#tab17" role="tab"
								aria-controls="tab17" aria-selected="false">Excursion</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab18-tab" data-toggle="tab" href="#tab18" role="tab"
								aria-controls="tab18" aria-selected="false">CNA Activity</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="col-md-9">
				<div class="tab-content" id="myTabContent">
					<div class="tab-pane fade show active" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">
						<div class="section-title">
							<h4>NSS Activity
							</h4>

						</div>
						<div class="text-justify">
							<p>The main objectives of GHRCCST's National Service Scheme (NSS) </p>
							<ul class="list-item mb-2">
								<li>Understand the community in which they work, </li>
								<li>Understand themselves in relation to their community, </li>
								<li>Identify the needs and problems of the community and involve them in
									problem-solving.</li>
								<li>Develop among themselves a sense of social and civic responsibility.</li>
							</ul>
							<p>It provides opportunity to the student youth of BBA & BCCA to take part in various
								government led community service activities &amp; programs. The sole aim of the NSS is
								to provide hands on experience to young students in delivering community service.
								Being an active member these student volunteers would have the exposure and experience
								to be the following:
							</p>
							<ul class="list-item mb-2">
								<li>an accomplished social leader</li>
								<li> an efficient administrator </li>
								<li>a person who understands human nature.</li>
							</ul>
							<p>GHRCCST's NSS is focus on developing overall personality of student & it’s reflection in
								society while delivering services. NSS is teaching tool for discipline, etiquettes, time
								management, thought process etc.</p>
							<p>GHRCCST's NSS used to conduct several important activities for youth & for society also.
								We deliver value based, skills based teaching & learning environment to students for
								maximum participation.
							</p>
						</div>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss-camp-khapa-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss-camp-khapa-1.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>NSS Camp Khapa</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss-camp-khapa-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss-camp-khapa-2.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>NSS Camp Khapa</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss-camp-khapa-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss-camp-khapa-3.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>NSS Camp Khapa</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss-camp-khapa-4.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss-camp-khapa-4.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>NSS Camp Khapa</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss-camp-khapa-5.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss-camp-khapa-5.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>NSS Camp Khapa</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss-camp-khapa-6.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss-camp-khapa-6.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>NSS Camp Khapa</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/diabetes-camp.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/diabetes-camp.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Children Recreation Activity</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/swachh-bharat.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/swachh-bharat.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Swach Bharat Abhiyan </h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/diebties-check.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/diebties-check.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Diebties Check up</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/swachh-bharat-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/swachh-bharat-1.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Swach Bharat Abhiyan </h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/terrorism-hinsachar.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/terrorism-hinsachar.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Terrorism Hinsachar</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss-tikakaran.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss-tikakaran.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Tikakaran Utsav </h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss-noone.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss-noone.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Noone is Stray 2021</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss-meditation.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss-meditation.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Meditation Program </h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss-hedgewar.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss-hedgewar.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Dr. Hedgewar Jayanti </h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss-ambedkar.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss-ambedkar.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Dr. Ambedkar Jayanti </h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss-food-distibution.webp"
										data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss-food-distibution.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Distribution of Food </h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss-cloth-donation.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss-cloth-donation.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Cloths Donation </h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss_ny.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss_ny.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>National Youth Day</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss_rp_d.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss_rp_d.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Republic Day</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss_sdt.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss_sdt.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Self Defence</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss_tb.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss_tb.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>TB Awareness</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss-beti-bachao.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss-beti-bachao.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Beti Bachao Beti Padhao rally 2021</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/nss_siss.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/nss_siss.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Sports Interaction with Slum Soccer Scotland Team.</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/vaccination-camp.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/vaccination-camp.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Vaccination Drive on Children’s Day 2021</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
						<h4>NSS Activity
						</h4>
						<ul class="list-item link-list">
							<li><a href="https://drive.google.com/file/d/1B5uzxatyYjQvOoHxgEGLDe-NhLV_Ex9U/view?usp=sharing"
									target="_blank">NSS Report Sambhaji Maharaj Jayanti</a></li>
							<li><a href="https://drive.google.com/file/d/1C9UZ8HDW5ktAXsNABolpPQaKe0scimG0/view?usp=sharing"
									target="_blank">NSS Report the great debate</a></li>

							<li><a href="https://drive.google.com/file/d/1g8CHXUfP7TpcaUrgFWQ68quKfMExII5A/view?usp=sharing"
									target="_blank">Constituition Day 2020 GHRCCST Nagpur</a></li>
							<li><a href="https://drive.google.com/file/d/12BvgqnZSy7hkLMAWRuIhc24CFu-fUy2l/view?usp=sharing"
									target="_blank">NSS Camp Khapa (Patan) 2021-22 GHRCCST Nagpur</a></li>
							<li><a href="https://drive.google.com/file/d/1UHF-RHGVnpV1QfexF4-EqnLOSG62Dbk1/view?usp=sharing"
									target="_blank">NSS Juvenile Visit Report</a></li>
							<li><a href="https://drive.google.com/file/d/1mhpILXYk9q5Wf5GR508OjmueHCrehtEi/view?usp=sharing"
									target="_blank">NSS report minority day celebration 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1Z-Qa25BPQnuYcvhZNFnSb2siNWhoySZ6/view?usp=sharing"
									target="_blank">NSS Report National Farmers Day 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1YeIxNj4qxA1b1RKGG6IYcmdTE5AWuJ6Y/view?usp=sharing"
									target="_blank">NSS Report National Voter’s Day</a></li>
							<li><a href="https://drive.google.com/file/d/1XLD0gnl8JBeVnxFoGEqkN20IXDOwHICD/view?usp=sharing"
									target="_blank">NSS report National Youth Day celebration 2022</a></li>
							<li><a href="https://drive.google.com/file/d/1JSb1KNBR3CvjJRw-jR6bHWtYq0RymZ21/view?usp=sharing"
									target="_blank">NSS report on “Gurunanak Jayanti” 2021 </a></li>
							<li><a href="https://drive.google.com/file/d/1sVpOURNj42hEGAN9WHszUkZ50BFXDuqC/view?usp=sharing"
									target="_blank">NSS report on Covid Vaccination Campaign 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1maN05-iFFC-42folr8ADSmv2o5FQlj74/view?usp=sharing"
									target="_blank">NSS report on Deep Ramzan 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1IKBfydYQIbIyyOPKFV7YrcKMRvw51uKw/view?usp=sharing"
									target="_blank">NSS report on Indian Navy Day 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1ht1E2X3pWJKwG01wYUw4QjPgTcfbK_Vm/view?usp=sharing"
									target="_blank">NSS Report on National Girl Child Day</a></li>
							<li><a href="https://drive.google.com/file/d/1i74TSmputmvAFjNXBftUo65sgBf4UWru/view?usp=sharing"
									target="_blank">NSS Report on National Martyrs Day</a></li>
							<li><a href="https://drive.google.com/file/d/1k0ZiCaIe1yL4whOfwdPnpuxTtHxIBZhj/view?usp=sharing"
									target="_blank">NSS Report on National Tourism Day</a></li>
							<li><a href="https://drive.google.com/file/d/1fMv3GzevNAWFqAqTT_sxfVvbuKytTKHb/view?usp=sharing"
									target="_blank">NSS report on National Unity Day 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1LGY-vuQsNQoaTZUjZJB2DibcbNCJqKAO/view?usp=sharing"
									target="_blank">NSS report on Plantation 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1X99iTePzwLv5jMkNWtUVUCj_J6Td1QGA/view?usp=sharing"
									target="_blank">NSS Report on Self Defense Campaign</a></li>
							<li><a href="https://drive.google.com/file/d/1HLkO43f6B8o0qF5Q1kJcMTmDD7A2jDmU/view?usp=sharing"
									target="_blank">NSS Report on Signature campaign</a></li>
							<li><a href="https://drive.google.com/file/d/1uVSebLArTmw2-ESf1YVYSD1mOkf4KGxY/view?usp=sharing"
									target="_blank">NSS Report Women’s Day</a></li>
							<li><a href="https://drive.google.com/file/d/1qQpz6EUc8F_uhR_nwumSUigMP0h6xRzW/view?usp=sharing"
									target="_blank">NSS Swach Bharat Abhiyan at bus and railway station 2021 Notice</a>
							</li>
							<li><a href="https://drive.google.com/file/d/1ekTHl8bOwCQrrhaHUNjk5XxmauDL53z8/view?usp=sharing"
									target="_blank">NSS wing report on Cleanliness Drive 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1DNi5ciJElpak0hZ1WLShziUIjKMq__2F/view?usp=sharing"
									target="_blank">NSS Day Against Terrorism and Hinsachar 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1Afq6-v0sJsfcnrnFnwq7eSJhBZU6SdIo/view?usp=sharing"
									target="_blank"> Beti bachao beti padhao 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1H98huePUz0xAxwa1IWom2N3G9PetXA5t/view?usp=sharing"
									target="_blank"> Birth Anniversary of Dr. B R Ambedkar</a></li>
							<li><a href="https://drive.google.com/file/d/1GP4J4dul8GVWMY_yJ_SzMTCslTJZwtOR/view?usp=sharing"
									target="_blank"> Birth Anniversary of Guru Nanak Dev Ji 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1SHEs-1Tl6NQGB0Jr7qlNtEDjQyi-b7ym/view?usp=sharing"
									target="_blank"> Birth Anniversary of Maharana Pratap 2021</a></li>
							<li><a href="https://drive.google.com/file/d/17AsRuzoOpsLJUr4o3dJ-_YIoQ9GCbgx9/view?usp=sharing"
									target="_blank"> Birth Anniversary on Jyotiba Phule 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1OKJjiy5lomnAd1i1ACyXYKUunyanjZzd/view?usp=sharing"
									target="_blank"> Birth Anniversary on Keshav Baliram Hedgewar 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1ZLkSDEDmYuYCffPXpN52FevQmx_bIgx8/view?usp=sharing"
									target="_blank"> Chhatrapati Shivaji Maharaj jayanti 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1-T3eNDD0QtkdIZKazDOO153uj3Me21Ss/view?usp=sharing"
									target="_blank"> CLEAN KARONA 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1D5Dkk81YZxBDpqCU-uMmZewqv4lIIGGR/view?usp=sharing"
									target="_blank"> Earth Day Celebration 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1mjgrthhGf2h4sMdRcu1RXcDYDLXsZgJM/view?usp=sharing"
									target="_blank"> Guest lecture on Global Warming 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1pIJrR6vC-_xe-dNwP3PTen-bCMw_NMDk/view?usp=sharing"
									target="_blank"> MAHASHIVRATRI 2021</a></li>
							<li><a href="https://drive.google.com/file/d/16Nex8nMP4Fil2mFyPXKiylLfSoJnk80y/view?usp=sharing"
									target="_blank"> NO ONE IS STRAY 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1C-s-u_7yfZzptHlLsBLZ5nX80ZF8Qzmu/view?usp=sharing"
									target="_blank"> Singing Competition 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1qeyDSQWTdnFtUW5dwIxIXzSj80bF1cMi/view?usp=sharing"
									target="_blank"> Sahaj Yoga Meditation 2021</a></li>
							<li><a href="https://drive.google.com/file/d/1Y3UX80rKLiRvvm14aKu-v-Au3af0or3Q/view?usp=sharing"
									target="_blank"> Donation of Clothes</a></li>
							<li><a href="https://drive.google.com/file/d/1jAFPRZBLoTHnbe_v8EkHSwkm4KyPp6Hp/view?usp=sharing"
									target="_blank"> Report on “Diabetes camp, Recreation for children &amp; Swach
									Bharat Abhiyan” at Khapa (Patan)”</a></li>
							<li><a href="https://drive.google.com/file/d/1sVpOURNj42hEGAN9WHszUkZ50BFXDuqC/view?usp=sharing"
									target="_blank">Vaccination Drive on Children’s Day 2021</a></li>
						</ul>
					</div>
					<div class="tab-pane fade" id="tab5" role="tabpanel" aria-labelledby="tab5-tab">
						<div class="section-title">
							<h4>Aarambh Induction
							</h4>

						</div>
						<div class="text-justify">
							<blockquote>“Never stop learning, because life never stop teaching.”-Anonymous</blockquote>
							<p>This is exactly the vision the G H Raisoni College of Commerce, Science and Technology,
								Nagpur tend to imbibe in their students. And the initiation for the same, onsets from
								the Induction program-Aarambh!</p>
						</div>
						<ul class="list-item">
							<li>It is a 3 day program.</li>
							<li>It is organized by the college for the newly admitted
								students of BBA and BCCA.
							</li>
							<li>The Day 1 of the event includes inauguration, address of
								the coordinator and the charter-chariot installation.
							</li>
							<li>The Day 2 comprises of management games. It consists of
								number of mind games including battle field, memory
								game and the like. At the end of the second day, the
								students are required to present their learning outcome in
								the form of management perspective.
							</li>
							<li>The Day 3 is an open fete, wherein the groups of newly
								admitted students are required to sell their stalls to the
								attendees. This aids in showcasing the students’
								management skills in the form of leadership, team building
								and decision making.
							</li>
						</ul>
						<p>There is also the live Rock band performance for the students.</p>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/arambh-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/arambh-1.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Aarambh Induction</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/arambh-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/arambh-2.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Aarambh Induction</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/arambh-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/arambh-3.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Aarambh Induction</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/arambh-4.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/arambh-4.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Aarambh Induction</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/arambh-5.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/arambh-5.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Aarambh Induction</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/arambh-6.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/arambh-6.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Aarambh Induction</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="tab6" role="tabpanel" aria-labelledby="tab6-tab">
						<div class="section-title mb-4">
							<h4>Toastmaster
							</h4>

						</div>
						<div class="row">
							<div class="col-md-7">
								<div class="text-justify">
									<p>Raisoni Toastmasters provides a supportive and positive learning experience in
										which students are empowered to develop communication and leadership skills
										resulting in greater self confidence and personal growth</p>
									<p>Public speaking and leadership skills are the two sides of the same coin named
										TOASTMASTERS .</p>
									<p>Public speaking can make your heart skip a beat and ‘I am going to die on stage
										fear grips you'. But the speech assignments in Toastmasters helps you to
										research on the topic, it teaches you to get to the point ,organize your
										speeches and it also guides you how to present your speech, how to persuade and
										inspire your audience.Toastmasters is a perfect platform to grow as a speaker as
										well as an individual who can accept challenges and to overcome them with
										triumph.</p>

								</div>
							</div>
							<div class="col-md-5">
								<iframe src="https://drive.google.com/file/d/1hP9LCB88GR2DE7Xn0d92iPmyKR1QD1ey/preview?"
									width="100%" height="450px" frameborder="0"></iframe>
							</div>
							<div class="text-justify ml-2 mr-2">
								<p>It was rightly stated by Ralph Smedly the founder of TOASTMASTERS “But just what do
									we mean by ‘leadership’it would appear to be the capacity to look ahead ,think ahead
									,plan ahead ,and then influence other people to go ahead on the plan”. In leadership
									skills one can learn to inspire ,coach,support and delegate others.</p>
								<p>Being a part of toastmasters ,an individual displays improved communication skills
									and interpersonal relations. His personal growth is judged and appreciated by people
									around who do notice the changed personality ,but this change can be achieved only
									by achieving ones own personal goals along with the enhanced performance in the show
									of leadership skills.</p>
								<p>Weekly meetings ,Monthly contest [Inspirational,humorous,table topics,spin a
									yarn,evaluation],Toastfest [a three day event],Youth Leadership Programmes in
									different schools,Mega event of youth leader ship programmes,TM Achievers
									day,Hyderabad visits for various contest,Area governers and distinguished
									toastmasters coming to interact and guide the students in their Toastmasters journey
								</p>
								<p>We at Raisoni Toastmaster club have been very open in a variety of ways ,different
									view points,innovative approaches that makes the club atmosphere fresh and
									vibrant.New students enrolling every year are fascinated by this world of Raisoni
									Toastmasters .Sheer determination and hardwork has made us climb the ladder of
									success . We have climbed each rung of the ladder with caution and a never say die
									attitude which has helped us to achieve the coveted PRESIDENTIAL DISTINGUISHED
									2015-16. Stepping up from being SELECT DISTINGUISHED 2014-15,it really made us proud
									to become President Distinguished .PHOENIX award,GOLDEN EAGLE award for the best
									club at Hyderabad 2015-16 are a few more jewels added to our crown .CC’s ,CL’s and
									AC[BRONZE] accomplished by our students made us realize Raisoni Toastmasters is
									shinning ..3 of our students made history in Raisoni Toastmaster Club by completing
									ADVANCED COMMUNICATION BRONZE .Students participation in the clubs YLP to train
									young minds to become better orators of the future,has made us at Raisoni feel proud
									all the more . The newly introduced pathway also has the students actively
									introduced to it and nearly 10 of them are in level 4 already .</p>
								<p>We at Raisoni are basking in the warmth of our new found glory and hope our club
									keeps rising and rising beyond one’s imagination.</p>
								<p>We are here not to conquer the world but to set the adrenaline rushing of one and all
									through platform of “Toastmasters”.</p>
							</div>
						</div>
						<div class="row justify-content-center mb-20">

							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/toast-7.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/toast-7.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Toastmaster</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/toast-8.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/toast-8.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Toastmaster</h6>
										</div>
									</a>
								</div>
							</div>



							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/toast-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/toast-1.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Toastmaster</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/toast-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/toast-2.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Toastmaster</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/toast-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/toast-3.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Toastmaster</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/toast-4.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/toast-4.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Toastmaster</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/toast-5.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/toast-5.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Toastmaster</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/toast-6.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/toast-6.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Toastmaster</h6>
										</div>
									</a>
								</div>
							</div>
						</div>

						<!-- <h4>Toastmaster Newsletter</h4>
						<ul class="list-item link-list">
							<li><a href="https://drive.google.com/file/d/1HLlA6iSgiH8oLfPnW19apt-ochtvPY3u/view?usp=sharing" target="_blank" >Newsletter-April 2022</a></li>
							<li><a href="https://drive.google.com/file/d/1lgTV2DCUuAHAzzRdAt6qFVVgWw6XbCLW/view?usp=sharing" target="_blank" >Newsletter-March 2022</a></li>														
						</ul> -->
					</div>
					<div class="tab-pane fade" id="tab8" role="tabpanel" aria-labelledby="tab8-tab">
						<div class="section-title">
							<h4>Engfinity
							</h4>

						</div>
						<div class="text-justify">
							<p>The Engfinity club initiates various competitive activities throughout the year for BCCA
								Students to develop the LSRW skills in English language. The students develop
								interpersonal skills, presentation skills and public speaking through different levels
								of competitions. The club is divided in different houses further and led by student
								mentors and co-mentors. Hence the club is of the students, for the students and by the
								students. The students conduct the activities like speeches, skits, drama, making
								documentary and short films etc under the supervision of the coordinator of the club
								Prof. Kalyani N Dubey and HOD BCCA Prof. Madhuri Barua. The club has taken a giant leap
								of success in the past three years under the guidance and motivation of Dr.Aarti
								Deshpande , Director, Raisoni business School and Principal Dr. Jasvinder Kaur. The
								Engfinity Club has been proven a mile stone for BCCA students in developing their
								Listening, Speaking, Reading and writing skills. It is a highly participated club.</p>
						</div>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/Engfinity-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/Engfinity-1.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Activitiy Representers</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/Engfinity-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/Engfinity-2.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Month end Presentation</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/Engfinity-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/Engfinity-3.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Student Teacher Interaction</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/Engfinity-4.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/Engfinity-4.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Weekly presentation</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
						<h5 class="text-center">Engfinity Club Installation Press Release</h5>
						<p>The Engfinity Club Installation for the students of BCCA, BCA, BCom and BSc (all streams) in
							G H Raisoni College of Commerce Science & Technology took place with great fervor and
							enthusiasm recently.
						</p>
						<p>The club is meant for the enhancement of the basic English communication skills, public
							speaking, stage confidence and LSRW Skills among students of the college.
						</p>
						<p>The installation ceremony consisted of formal announcement of the club restructuring, Guest
							speeches, demonstration meet, extempore competition and fun filled language games and
							activities.
						</p>
						<p>The Chief guest of the event, Ms Salama Anjum, Associate Professor, Director, Ascendant
							Learning Centre Ltd, motivated all the students with her insightful words of wisdom.
						</p>
						<p>The event was blessed with the presence of the Director Raisoni Business School Dr. Aarti
							Deshpande. She praised the dedication of the teachers and students for setting the benchmark
							with the superb performances through this club time and again.
						</p>
						<p>The club incharge Prof. Kalyani Dubey threw light upon the overall journey of Engfinity club
							so far and inspired the students to keep ahead the spirit alive.
						</p>
						<p>The event was prominently attended by Dean Students' Activities & Progression and principal
							Dr. Jasvinder Kaur along with HODs and other staff members.
						</p>
						<p>The event was witnessed and appreciated by all students in huge numbers. The Program was a
							grand success.
						</p>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/engfinity-club-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/engfinity-club-1.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Activitiy Representers</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/engfinity-club-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/engfinity-club-2.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Month end Presentation</h6>
										</div>
									</a>
								</div>
							</div>

						</div>
						<h5 class="text-center">Engfinity 2021</h5>
						<p>The Engfinity Club conducted a mega event on Dec 23, 2021 in which the students of BCCA sem
							1, 2 &amp; 3 participated representing Lilac, Coral, Cyan and Ivory house.</p>
						<p>The theme of the event was The entertainment- Its Show Time. The students presented skits
							with a social message. The chief guest of the program was Ms Mrunali Sharma, H R Head of
							aXYKno Capital Services Pvt Ltd.</p>
						<p>The program was attended and highly appreciated by the director Raisoni Business School Dr
							Aarti Deshpande, Principal Dr. Jasvinder Kaur, Ms Madhuri Barua HOD, BCCA and all teaching
							and non- teaching staff. The students presented the promotional videos and digital posters
							alongwith the power packed skit performances. The mega event was designed and coordinated by
							the Engfinity club in- charge Ms Kalyani Dubey.</p>

						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/Engfinity-21-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/Engfinity-21-1.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Activitiy Representers</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/Engfinity-21-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/Engfinity-21-2.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Month end Presentation</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/Engfinity-21-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/Engfinity-21-3.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Student Teacher Interaction</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
						<ul class="list-item link-list">
							<!-- <li><a href="https://drive.google.com/file/d/1z6ItEQrYSyhinwegm-0gVc4HkFJGRrhh/view?usp=sharing" target="_blank">  Engfinity Club Installation Ceremony 22-23</a></li> -->
							<li><a href="https://drive.google.com/file/d/1hbykE1ZxT-2g4SrH-woEXXzbdkIJecxB/view?usp=sharing"
									target="_blank"> Engfinity Club Installation Ceremony 22-23</a></li>
						</ul>

						<ul class="list-item link-list">
							<!-- <li><a href="https://drive.google.com/file/d/1TPFCpjlbC9wGfbuslyaoKo3c39RVMPQF/view?usp=sharing" target="_blank">The Engfinity Club Mega Event Press Note</a></li> -->
							<li><a href="https://drive.google.com/file/d/1EbkVyxrpv_93A1MaelpUH6FGZAWFR9pG/view?usp=sharing"
									target="_blank">The Engfinity Club Mega Event Press Note</a></li>
						</ul>


					</div>
					<div class="tab-pane fade" id="tab11" role="tabpanel" aria-labelledby="tab11-tab">
						<div class="section-title">
							<h4>Short term course
							</h4>

						</div>
						<div class="text-justify">
							<p>Certification courses are basically worked for students as a part of value addition
								program providing content beyond syllabus. These certificate courses last from 30 to 45
								hours depending on the nature of the course. Today, GHRCCST offers a wide range of
								certificate courses ranging from banking, computer, finance, marketing, business
								simulation, commerce and many more. With the support of long list of certificate courses
								the students can easily make out their best choice as per their interest and career
								goals. These courses go in a long way in bridging the gap between campus to corporate.
								Short term certified courses concentrates on skill enhancement and opportunities for
								generating more employment for the students. The college has taken initiative in
								floating large number of courses like, Basic & Advanced Simulation, CRT training,
								Digital Marketing, Understanding financial statements to name a few.</p>
							<p>Characteristics of certificate courses offered by GHRCCST are:</p>
						</div>
						<ul>
							<li>Regular intervention of assignments, group discussion within the courses.</li>
							<li>Detail course learning with deep modules strategy.</li>
							<li>Practical knowledge along with theoretical classes.</li>
							<li>Availability of latest research and development tools along with fitted laboratories,
								well equipped class rooms and many more.</li>
							<li>Strict discipline and world class study infrastructure where student can easily go
								through their course modules.</li>
							<li>Analyzes and regular assessment mode of students performance.</li>
						</ul>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/stc_exel.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/stc_exel.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Basic & Advance Excel</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/stc_simu.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/stc_simu.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Basic & Advanced Simulation</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/stc-dig.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/stc-dig.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Digital Marketing</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/stc-fina.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/stc-fina.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Reading of financial statements</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="tab15" role="tabpanel" aria-labelledby="tab15-tab">
						<div class="section-title">
							<h4>Sahas – Adventure Camp
							</h4>

						</div>
						<div class="text-justify">
							<p>The College organizes two days adventure camp in the name of “SAHAS”. The camp is
								exclusively for the College student only. The aim behind the camp was to teach the
								students various management skills and also to make them understand the importance
								strategic and tactical planning decision making. Various adventure activities like 100
								feet wall climbing, guerilla techniques, rappelling, forest treasure hunt, water sports
								night safari etc. are provided to the students. Large number of students participate and
								take maximum learning benefits from the camp. It is totally free of cost for the
								students</p>
						</div>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sahas-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sahas-1.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Sahas – Adventure Camp</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sahas-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sahas-2.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Sahas – Adventure Camp</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sahas-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sahas-3.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Sahas – Adventure Camp</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sahas-4.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sahas-4.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Sahas – Adventure Camp</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sahas-5.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sahas-5.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Sahas – Adventure Camp</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sahas-6.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sahas-6.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Sahas – Adventure Camp</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sahas-7.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sahas-7.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Sahas – Adventure Camp</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sahas-8.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sahas-8.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Sahas – Adventure Camp</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sahas-9.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sahas-9.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Sahas – Adventure Camp</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sahas-10.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sahas-10.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Sahas – Adventure Camp</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sahas-11.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sahas-11.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Sahas – Adventure Camp</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="tab16" role="tabpanel" aria-labelledby="tab16-tab">
						<div class="section-title">
							<h4>Saraswati Pooja
							</h4>

						</div>
						<div class="text-justify">
							<p>Maa Saraswati is the goddess of knowledge, music, arts and nature. Saraswati represents
								intelligence, consciousness, creativity, education and enlightment of soul. Saraswati
								Pooja is celebrated on the occasion of Vasant Panchami in the presence of all the
								Principal, Staff and Students of GHRCCST. The celebration is witnessed by beautiful
								decoration of Maa Saraswati idol with flowers, lighting and Rangoli. Chapan Bhog is
								offered as Prasad to the deity. All the students and staff were dressed in traditional
								attire.</p>
						</div>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sarswati-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sarswati-1.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Saraswati Pooja</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sarswati-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sarswati-2.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Saraswati Pooja</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sarswati-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sarswati-3.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Saraswati Pooja</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sarswati-4.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sarswati-4.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Saraswati Pooja</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sarswati-5.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sarswati-5.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Saraswati Pooja</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sarswati-6.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sarswati-6.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Saraswati Pooja</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/sarswati-7.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/sarswati-7.webp" alt="Campus Liffe | Ghrcacsn"
											title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Saraswati Pooja</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="tab17" role="tabpanel" aria-labelledby="tab17-tab">
						<div class="section-title">
							<h4>Excursion
							</h4>

						</div>
						<div class="text-justify">
							<p>G H Raisoni College of Commerce Science & Technology organize every year National &
								International excursion for its students. National excursion is for a period of 10 days
								where as International excursion is for 6 days .Excursion is organized by the college as
								a stress buster for its students. The basic objective behind this activity is to
								enlighten the students with the culture, tradition and heritage of the place visited.
								Various sightseeing along with camp fire etc. are enjoyed by the students in excursion.
							</p>
							<p>Students have a good chance to explore the rich diversity and broaden their perspective
								and outlook by experiencing social interaction amongst them. Various locations in India
								from North to South and East to West are covered every year in National excursion. As
								far as International excursion is concerned mostly Asian countries are preferred as per
								student’s choice.</p>
						</div>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/excursion-1.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/excursion-1.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>International Tour</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/excursion-2.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/excursion-2.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>National Tour</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/excursion-3.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/excursion-3.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>International Tour</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/excursion-4.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/excursion-4.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>International Tour</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/excursion-5.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/excursion-5.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>National Tour</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/excursion-6.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/excursion-6.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>National Tour</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="tab18" role="tabpanel" aria-labelledby="tab18-tab">
						<div class="section-title">
							<h4>CNA Activity
							</h4>

						</div>
						<div class="text-justify">
							<p>CNA forum and IT forum Of G H Raisoni College of Commerce Science and Technology recently
								launched its magnificent BlogSpot - Meri Kalam Se for its stakeholders on August 3,
								2021. The BlogSpot is meant to provide a platform to showcase Brain power through pen
								power.A blogger can contribute in form of poem, stories, anecdote thoughts or any
								literary work in three languages i.e. English, Hindi and Marathi. The contents will be
								based upon monthly themes.</p>
							<p>The students worked significantly for the concept and launch of the blog were the invited
								students of RBS named Ms Sakshi Mardana, Ms Bhavika Krishnani, Ms Namita Bose, Mr
								Bhushan Shelke, Mr Pratik Jawanjal , Ms Payal Balpande along with the students of BBA
								&amp; BCCA Of G H RCCST named Mr Kushagra Lakhote, Prachi Chandekar, Himanshi Kandhari,
								Harshwardhan, Apeksha Bhanuse and Kaif Ali.</p>
							<p>The activity was initiated under the guidance of Principal GHRCCST Dr. Jasvinder Kaur,
								Dr. AArti Deshpande, Director, RBS, Ms Madhuri Barua,HOD BCCA, G H RCCST, Prof Kalyani
								Dubey, CNA Forum incharge and Dr Ashwin Ankar &amp; Prof Vishal Dhabalia, IT forum
								incharge.</p>
						</div>
						<div class="row justify-content-center mb-20">
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/do-you-know-cna.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/do-you-know-cna.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Do You Know?..</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/engfinity-club-cna.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/engfinity-club-cna.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>Engfinity Club Installation</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/gallery/gd-series-cna.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/gallery/gd-series-cna.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>GD Series activity</h6>
										</div>
									</a>
								</div>
							</div>
							<div class="col-lg-3 col-6 col-md-4">
								<div class="gallery-item" data-aos="zoom-in-down">
									<a href="assets/images/latest-news/cna-forum.webp" data-lightbox="example-set"
										data-title="GHRCCST GALLERY GLIMPSES">
										<img class="img-fluid" src="assets/images/latest-news/cna-forum.webp"
											alt="Campus Liffe | Ghrcacsn" title="Campus Liffe | Ghrcacsn">
										<div class="gallery-overlay">
											<h6>CNA forum</h6>
										</div>
									</a>
								</div>
							</div>
						</div>
						<h4>CNA Activity</h4>
						<ul class="list-item link-list">
							<!-- <li><a href="https://drive.google.com/file/d/1212wDue7ZZZ6drj-Kvj-lIVmc0VBo5HH/view?usp=sharing" target="_blank">The CNA Forum Installation Press Note</a></li> -->
							<li><a href="https://drive.google.com/file/d/1-XOTcdFZWjMNeiO9P1CBL1yaYknbWDMY/view?usp=sharing"
									target="_blank">The CNA Forum Installation Press Note</a></li>
							<li><a href="https://drive.google.com/file/d/1xcVmfQ-LOwRqKxPyBIc-so2B2PvmqLG7/view?usp=sharing"
									target="_blank">Engfinity Club Installation Press Release</a></li>
							<!-- <li><a href="https://drive.google.com/file/d/10YW7qngRWMeXJrX9cgA9RvR-HikSIzPW/view?usp=sharing" target="_blank">Do You Know?.....</a></li> -->
							<li><a href="https://drive.google.com/file/d/1deoPQt1WlHu5UMOt9h3lWoVCpJbDnPQ6/view?usp=sharing"
									target="_blank">Do You Know?.....</a></li>
							<!-- <li><a href="https://drive.google.com/file/d/1Ha0PwjTWKLPNg3v9EONaogiTu5UWziq5/view?usp=sharing" target="_blank">GD Series activity</a></li> -->
							<li><a href="https://drive.google.com/file/d/1EdomWBUXfYu4vVcmEADlYrLlBwuTXdYJ/view?usp=sharing"
									target="_blank">GD Series activity</a></li>
							<!-- <li><a href="https://drive.google.com/file/d/1h02CXnczXjQD6PCkgo8qCjdTC3pc5u79/view?usp=sharing" target="_blank">CNA forum </a></li> -->
							<li><a href="https://drive.google.com/file/d/1lGyCZbdcu-cg-CypWQnurTODEO1uTv6-/view?usp=sharing"
									target="_blank">CNA forum </a></li>
							<!-- <li><a href="https://drive.google.com/file/d/1HiHl5LAxqrZPqCwwcwUPHDFei8M3ecHB/view?usp=sharing" target="_blank">Brainista- The Quiz Competition Under CNA Forum- Press Release </a></li> -->
							<li><a href="https://drive.google.com/file/d/1n5q5y13A340M4DGoPCFJFLDkgwQjE8v_/view?usp=sharing"
									target="_blank">Brainista- The Quiz Competition Under CNA Forum- Press Release </a>
							</li>
							<!-- <li><a href="https://drive.google.com/file/d/1EV4fW7dPNCryqF_UbCQoqOKgStaW2qkY/view?usp=sharing" target="_blank">The News Analysis Competition </a></li> -->
							<li><a href="https://drive.google.com/file/d/1nppG8lBNq4D6tBEatiWWhva10o3eBnXV/view?usp=sharing"
									target="_blank">The News Analysis Competition </a></li>

						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>